<div class="col-12 container">
    <div class="container" style="margin: 0 auto; max-width: 90%; padding: 0px 0;">
        <div class="logodetails" fxLayout="row">
            <div fxFlex="70" class="logo col-12 col-md-7 col-lg-10 col-xl-10">
                <img class="companylogo" [src]="imageUrl" alt="logo" />
                <!-- <span class="footer-heading logoname" style="color: #fff;">L&T Technology Services</span> -->
            </div>
    
            <div class="divider-footer-mobile"></div>
    
            <div fxLayout="row" fxFlex="30" class="links col-12 col-md-5 col-lg-2 col-xl-2">
    
                <div fxFlex="30" fxLayoutAlign="center center" class="cursor"
                    (click)="openLink('https://www.linkedin.com/company/1739031/', 'linkedin')">
                    <img class="linkedin" src="assets/icons/lnvector.png" alt="img">
    
                </div>
                <div fxFlex="30"  fxLayoutAlign="center center" class="cursor"
                    (click)="openLink('https://www.youtube.com/channel/UCxrAGA4YYput8eQQtn62mUg', 'YouTube')">
                    <img class="youtube" src="assets/icons/youtube.png" alt="img">
                </div>
                <!-- <div fxFlex="25" fxLayoutAlign="center center" class="cursor"
                    (click)="openLink('https://twitter.com/LnTTechservices', 'Twitter')">
                    <img class="twitter" src="assets/icons/twitter.png" alt="">
                </div> -->
                <div fxFlex="30" fxLayoutAlign="center center" class="cursor"
                    (click)="openLink('https://www.ltts.com/', 'LTTSWebsite')">
                <img class="browser" src="assets/icons/browser.png" alt="img">
            </div>
            </div>
        </div>
    
        <div class="divider-footer">
        </div>
        <div class="section-2" fxLayout="row">
            <div style="padding: 0px;" class="rights col-12 col-md-7 col-lg-8 col-xl-8">
                © 2026 L&T Technology Services Limited. All Rights Reserved
            </div>
            <div fxLayout="row"  class="col-12 col-md-5 col-lg-4 col-xl-4 privacy">
                <div   style="border-right: 1px solid #fff;padding-right: 40px;"><a (click)="copyrightclick()" href="https://www.ltts.com/copyright-terms" target="_blank" rel="noopener">COPYRIGHT &
                        TERMS</a></div>
                <div class="policy" style="padding-left: 40px;" ><a (click)="privacyclick()" href="https://www.ltts.com/privacy-policies-notices"
                        target="_blank" rel="noopener">PRIVACY</a></div>
            </div>
            <div style="padding: 0px;" class="rights-mobile col-12">
                © 2026 L&T Technology Services Limited. All Rights Reserved
            </div>
        </div>
    </div>
</div>